import { Box } from '@mui/material';
import { observer, useLocalObservable } from 'mobx-react-lite';
import RestaurantInfo, { RestaurantInfoCardConfig } from '../group/restaurant-manager/restaurant-info';
import { RestaurantInfoState } from '../group/restaurant-manager/restaurant-info-state';

/**
 * 餐厅资源回收详情
 */
const DeleteRestaurantDetail = observer((props: DeleteGroupDetailProps) => {

    const { selectId, belonged_group } = props;

    const restaurantInfoState = useLocalObservable(() => new RestaurantInfoState({
        componentType: 'PREVIEW',
        restaurantId: selectId,
        belonged_group,
    }));

    // 餐厅表单基础数据
    const restaurantData = RestaurantInfoCardConfig;

    return (
        <Box>
            <RestaurantInfo restaurantInfoState={restaurantInfoState} RestaurantInfoCardConfig={restaurantData} />

        </Box>
    )
});

export default DeleteRestaurantDetail;

type DeleteGroupDetailProps = {
    // 选择的餐厅id
    selectId?: string;
    // 餐厅所属集团
    belonged_group?: string;
}